/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const chevronDown = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="M17.5 11.6L12 16l-5.5-4.4.9-1.2L12 14l4.5-3.6 1 1.2z" />
	</SVG>
);

export default chevronDown;
